// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2RRuW","subheader":"ReorderModal_subheader__3YkRs","listWrap":"ReorderModal_listWrap__xw5I6"};